import client from '@contentful/client'
import { faqFragment } from '@contentful/faq'
import { gql } from '@apollo/client'
import { GetStaticProps } from 'next'
import { pageIds } from '@config/contentful'
import Page from '@components/common/Page'
import RichTextBlock from '@models/projects/interfaces/richText.interface'
import HowToParticipatePage from '@components/howToParticipate/HowToParticipatePage'

interface IndexProps {
  faqs: {
    question: string
    answer: RichTextBlock
  }[]
}

const Index: React.FC<IndexProps> = ({ faqs }) => {
  return (
    <Page title="How to participate">
      <HowToParticipatePage faqs={faqs} />
    </Page>
  )
}

export const getStaticProps: GetStaticProps = async () => {
  const { data, error } = await client.query({
    query: gql`
      query FaqPageQuery($preview: Boolean!, $pageId: String!) {
        faQs(id: $pageId, preview: $preview) {
          ...faqFields
        }
      }
      ${faqFragment}
    `,
    variables: {
      preview: process.env.CONTENTFUL_PREVIEW_MODE,
      pageId: pageIds.faq
    },
    fetchPolicy: 'network-only'
  })

  return {
    props: {
      faqs: data?.faQs?.faqs?.items || [],
      error: error?.message || ''
    },
    revalidate: 60
  }
}

export default Index
